<div scId="SC1026" class="row" *ngIf="waitForRoles">
  <div class="col-12 text-center">
    <i class="fa fa-spinner fa-pulse spinner-icon"></i>
  </div>
</div>
<div class="row" *ngIf="loadingStatus">
  <div class="col-12 text-center">
    <i class="fa fa-spinner fa-pulse spinner-icon"></i>
  </div>
</div>

<tmo-dynamic-modal [modal]="validatePinModal">
  <ng-container header>
    <div class="row">
      <div class="col-12">
        <h3>To access your account, we need to verify your PIN/Passcode.</h3>
      </div>
    </div>
  </ng-container>
  <div class="row">
    <div class="col-12 m-t-md">
      <tmo-input
        [maxlength]="6"
        [type]="'password'"
        #pinInput
        [placeholder]="'Enter Pin number'"
        [pattern]="'^[0-9]*$'"
      ></tmo-input>
    </div>
  </div>
  <p class="small m-t-lg">PIN must be at least 4 digits</p>
  <p *ngIf="invalidPinError" class="alert-text m-t-sm m-t-md">
    <i class="fa fa-flag def alert-icon"></i>
    <span> Hmm, that PIN doesn't match our records. Give it another shot. </span>
  </p>
  <tmo-spinner [setDelay]="!profileMergingStatus"></tmo-spinner>
  <div class="row">
    <div class="col-12 buttons-container button-spacing">
      <div class="button-box">
        <button class="btn btn-secondary" (click)="signoutUnverifiedCustomer()">Logout</button>
      </div>
      <div class="button-box">
        <button
          class="btn btn-primary"
          [disabled]="pinInput?.value?.length < 4 || profileMergingStatus"
          (click)="validatePinAndMerge(pinInput?.value)"
        >
          Verify My PIN
        </button>
      </div>
    </div>
  </div>
  <p class="small m-t-lg">
    Your PIN/Passcode is an extra layer of security used to authenticate your account. Enter the
    PIN/Passcode you set up during your account activation below.
  </p>
</tmo-dynamic-modal>

<tmo-static-modal
  [modal]="verifyPinErrorModal"
  (onSelect)="handlePinErrorModal($event)"
></tmo-static-modal>
